<template>
    <div class="orderDetail">
        <!-- (initial.待付款，paid.待发货， deliver.待收货，delivered.已收货) -->
        <div class="order-status" v-if="orderDetail.order_status=='initial'">等待买家付款</div>
        <div class="order-status" v-if="orderDetail.order_status=='paid'">等待卖家发货</div>
        <div class="order-status" v-if="orderDetail.order_status=='deliver'">卖家已发货</div>
        <div class="order-status" v-if="orderDetail.order_status=='delivered'">交易成功</div>
        <div class="order-status" v-if="orderDetail.order_status=='canceled'">订单已取消</div>
        <div class="address-box">
            <div>
                <span class="title-left">收货人：</span>
                <span>{{address.contact_name}}</span>
            </div>
            <div>
                <span class="title-left">收货地址：</span>
                <span class="address-info">
                    <div>{{address.area}}{{address.address}}</div>
                    <div>{{address.cellphone}}</div>
                </span>
            </div>
        </div>
        <div class="store-content">
            <div>
                <div class="store-title">
                    <span class="store-name">{{product1.merchant_name}}</span>
                </div>
                <!-- <mt-cell v-for="product in products" :key="product.id" :label="product.spec" :title="product.title" is-link @click="openProduct($event)" :data-product-id="product.product_id">
                    <span class="normal-price" v-if="product.price==product.vip_price">￥{{product.price}}</span>
                    <span v-else>
                        <span class="vip-price" >￥{{product.vip_price}}</span>
                        <span class="original-price">￥{{product.price}}</span>
                    </span>
                    <span class="amount">x{{product.amount}}</span>
                    <img slot="icon" :src="product.cover_image" @click="openProduct($event)" :data-product-id="product.product_id">
                </mt-cell> -->
                <div  v-for="product in products" :key="product.id" is-link @click="openProduct($event)" :data-product-id="product.product_id" style="display:flex" class="product_list">
                    <div class="left">
                        <img slot="icon" :src="product.cover_image" @click="openProduct($event)" :data-product-id="product.product_id">
                    </div>
                    <div class="right">
                        <div class="top">
                            <span class="title">{{product.title}}</span>
                            <span class="normal-price" v-if="product.price==product.vip_price">￥{{product.price}}</span>
                            <span v-else style="text-align:right;float:right">
                                <span class="vip-price" >￥{{product.vip_price}}</span>
                                <span class="original-price">￥{{product.price}}</span>
                            </span>
                        </div>
                        <div class="bottom">
                            <span class="spec">{{product.spec}}</span>
                            <span class="amount">x{{product.amount}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="total-price">
                <div><span>运费</span><span class="right">￥{{orderDetail.express_price}}</span></div>
                <div><span>实付款（含运费）</span><span class="right right-total">￥<span class="big-price">{{vip_total_price.split('.')[0]}}</span>.{{vip_total_price.split('.')[1]}}</span></div>
            </div>
            <div class="operate-btns">
                <!-- (initial.待付款，paid.待发货， deliver.待收货，delivered.已收货) -->
                <mt-button type="default" v-if="orderDetail.order_status!=='initial'" :data-order-no="orderDetail.order_no" @click="delOrder($event)">删除订单</mt-button>
                <mt-button type="default" v-if="orderDetail.order_status=='deliver'||orderDetail.order_status=='delivered'" @click="expressInfo($event)" :data-order-id="orderDetail.order_id">查看物流</mt-button>
                <!-- <mt-button type="default" v-if="orderDetail.order_status=='deliver'" :data-order-no="orderDetail.order_no">确认收货</mt-button> -->
                <mt-button type="default" @click="openProduct($event)" :data-product-id="product1.product_id">再次购买</mt-button>
                <mt-button type="default" v-if="orderDetail.order_status=='initial'" :data-order-no="orderDetail.order_no" @click="cancelOrder($event)">取消订单</mt-button>
                <mt-button type="default" v-if="orderDetail.order_status=='initial'" :data-order-id="orderDetail.order_id" @click="pay($event)">去支付</mt-button>
            </div>
        </div>
        <div class="order-box">
            <div>
                <span class="title-left">订单号：</span>
                <span>{{orderDetail.order_no}}</span>
            </div>
            <div>
                <span class="title-left">下单时间：</span>
                <span class="address-info">{{orderDetail.create_time | formatTime()}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import {formatTime} from '../util/format.js'
import {setData} from '../util/setData.js'
export default {
  name: 'myOrders',
  data () {
    return {
        orderDetail:{},
        address:{},
        products:{},
        product1:{
            merchant_name:'',
            product:''
        },
        vip_total_price:'',
        // platform_user_id:'9cc769a0-3369-11e9-8717-0242ac110029'
    }
  },
  beforeCreate:function(){
  },
  created:function(){
    
  },
  mounted:function(){
    this.order_id = this.$route.query.order_id;
    this.platform_user_id = this.$route.query.platform_user_id;
    console.log(this.order_id)
    this.showOrderDetail();
  },
  methods:{
    showOrderDetail(){
        let that = this
        console.log(that.order_id)
        let datas= {
            platform_user_id:that.platform_user_id,
            order_id:that.order_id
        }
        let datas_new = setData(datas)//数据加密
        that.$axios.get("order/detail",{
            params:datas_new
        })
        .then((res)=>{
            if(res.status == '200'){ 
                if(res.data.status_code=='200'){
                    console.log(res.data.data)
                    that.orderDetail=res.data.data
                    that.vip_total_price=res.data.data.vip_total_price
                    that.address=res.data.data.address
                    that.products=res.data.data.products
                    that.product1=res.data.data.products[0]
              }else{
                that.$message({
                  type: 'warning',
                  message: '获取数据有误，请刷新'
                });  
              }
            }
        })
        .catch(function(err){
            console.log(err);
            return false;
        })
    },
    // 取消订单
    cancelOrder(e){
        let that=this
        console.log(e.target.getAttribute('data-order-no'))
        that.$messagebox({
            title: '提示',
            message: '确定取消订单吗?',
            showCancelButton: true
        })
        .then(action=>{
            let order_no=e.target.getAttribute('data-order-no')
            let datas= {
                platform_user_id:that.platform_user_id,
                order_no:order_no
            }
            let datas_new = setData(datas)//数据加密
            console.log(datas_new)
            that.$axios({
                method:'post',
                url:'order/cancel',
                data:datas_new,
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then((res)=>{
                console.log(res)
                if(res.data.status_code == '200'){
                    that.current_page=1
                    that.showOrderDetail()
                }
            })
        }) 
        .catch(err => { 
            if (err == 'cancel') {     //取消的回调
                console.log(2);
            }
        })
    },
    //删除订单
    delOrder(e){
        let that=this
        console.log(e.target.getAttribute('data-order-no'))
        that.$messagebox({
            title: '提示',
            message: '确定删除订单吗?',
            showCancelButton: true
        })
        .then(action=>{
            let order_no=e.target.getAttribute('data-order-no')
            let datas= {
                platform_user_id:that.platform_user_id,
                order_no:order_no
            }
            let datas_new = setData(datas)//数据加密
            console.log(datas_new)
            that.$axios({
                method:'post',
                url:'order/delete',
                data:datas_new,
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then((res)=>{
                console.log(res)
                if(res.data.status_code == '200'){
                    that.$router.push({path:'/',params:{platform_user_id:that.platform_user_id},query:{platform_user_id:that.platform_user_id}})                    
                }
            })
        }) 
        .catch(err => { 
            if (err == 'cancel') {     //取消的回调
                console.log(2);
            }
        })
    },
    //查看物流
    expressInfo(e){
        let that=this
        console.log(e.target.getAttribute('data-order-id'))
        let order_id=e.target.getAttribute('data-order-id')
        let datas= {
            platform_user_id:that.platform_user_id,
            order_id:order_id
        }
        let datas_new = setData(datas)//数据加密
        console.log(datas_new)
        that.$axios.get("order/express",{
            params:datas_new
        })
        .then((res)=>{
            console.log(res)
            if(res.data.status_code == '200'){
                let com= res.data.data.com
                let sn= res.data.data.sn
                window.open('http://www.kuaidi100.com/chaxun?com=' + com + '&nu=' + sn); 
            }
        }) 
    },
    //打开商品详情
    openProduct(e){
        console.log(e.target.getAttribute('data-product-id'))
        let product_id=e.target.getAttribute('data-product-id')
        let ua= navigator.userAgent
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
        if(isAndroid){
            if(order){
                order.buyAgain(product_id) //vue给android传值; 
            }
        }else if(isiOS){
            window.webkit.messageHandlers.buyAgain.postMessage({
                product_id: product_id, //vue给iOS传值
            });
        }
    },
    pay(e){
        console.log(e.target.getAttribute('data-order-id'))
        let order_id=e.target.getAttribute('data-order-id')   
        let ua= navigator.userAgent
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
        console.log(isiOS)
        if(isAndroid){
            order.payAgain(order_id); 
        }else if(isiOS){
            window.webkit.messageHandlers.payAgain.postMessage({
                order_id: order_id, //vue给iOS传值
            });
        }
    }
  },
  filters:{
      formatTime(time){
        return formatTime(time);
      }
  },
}
</script>
<style lang="scss" scoped="" type="text/css">
.orderDetail{
    .order-status{
        width:100%;
        height:70px;
        background:linear-gradient(145deg,rgba(38,48,74,1) 0%,rgba(125,89,59,1) 100%);
        text-align: center;
        color:#fff;
        line-height:70px;
        font-size:18px;
    }
    .address-box,.order-box{
        background-color:#f8f8f8;
        padding:10px 20px 6px 9px;
        color:#333;
        font-size:14px;
        line-height:24px;;
        .title-left{
            width:70px;
            display:inline-block;
        }
        .address-info{
            display:inline-block;
            vertical-align:top
        }
    }
    .order-box{
        background-color:#fff;
    }
    .store-content{
        &::after{
        content:'';
        display:block;
        width:100%;
        height:9px;
        background-color:#eee;
    }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/orderDetail.vue